import React, {createContext, PropsWithChildren, useContext} from 'react';

import {School} from '../../../api/types/__generated__/data-contracts';

type SchoolAcademicYearTableContextValue = {
    onOpenChangeSchool: (school: School) => any
}

export const SchoolAcademicYearTableContext = createContext<SchoolAcademicYearTableContextValue>(null as any);

export const useSchoolAcademicYearTableContext = () => {
    return useContext(SchoolAcademicYearTableContext);
};

export const SchoolAcademicYearTableProvider = ({
    children, value
}: PropsWithChildren<{
    value: SchoolAcademicYearTableContextValue
}>) => {
    return (
        <SchoolAcademicYearTableContext.Provider value={value}>
            {children}
        </SchoolAcademicYearTableContext.Provider>
    );
};

export const withSchoolAcademicYearTableContextDecorator = (
    value: SchoolAcademicYearTableContextValue
// eslint-disable-next-line react/display-name
) => (Story: any) => {
    return <SchoolAcademicYearTableProvider value={value}>
        {Story()}
    </SchoolAcademicYearTableProvider>;
};
